// import { ContactComponent, FooterComponent, MenuComponent, TopArrowComponent } from '../components'
import { ContactComponent, TopArrowComponent, FooterComponent } from '../components'

export const TemplatePage = ({component}) => {
  return (
    <>
        {/* <MenuComponent /> */}
        { component }
        <ContactComponent />
        <TopArrowComponent />
        <FooterComponent />
    </>
  )
}
